import {handleActions} from 'redux-actions'
import {CUSTOM_FIELDS_SET} from './actionTypes'

const createCustomFieldsSelector = () => {
    const initialState = {
        items: [],
        isLoaded: false
    }
    return handleActions({
        [CUSTOM_FIELDS_SET]: (state, {payload: customFields}) => ({
            ...state,
            items: customFields,
            isLoaded: true
        })
    }, initialState)
}

export default createCustomFieldsSelector



// WEBPACK FOOTER //
// ./web/js/customFields/reducer.js